// A drilldown/modál TISZTA render-helperei (komponens-mentes, így a fast-refresh nem törik + közvetlenül unit-elhető).

import { sumDecimals } from '@atlas/shared';

export type DetailScope = 'client' | 'account';

/** Ügyfél/fiók-név a scope szerint (a legacy: client-scope → ügyfél (/ fiók), account-scope → fiók (/ ügyfél)). */
export function ownerLine(row: {
  scope: DetailScope;
  clientName: string;
  accountName: string;
}): string {
  if (row.scope === 'client') {
    return row.accountName ? `${row.clientName} / ${row.accountName}` : row.clientName;
  }
  return row.accountName
    ? row.clientName
      ? `${row.accountName} / ${row.clientName}`
      : row.accountName
    : row.clientName;
}

/**
 * A modál összesítő sora: a tétel-árak FIXPONTOS összege, 2 tizedesű Decimal-stringként.
 *
 * Pénz SOHA nem float — még akkor sem, ha a jelen bemenetek mellett a float-hiba nem jönne elő. A szabály
 * azért van, hogy ne kelljen minden híváson végiggondolni, hogy előjön-e; a `@atlas/shared` fixpontos
 * összegzője ugyanazt az aritmetikát használja, mint a szerver.
 */
export function detailTotal(rows: { price: string }[]): string {
  return sumDecimals(rows.map((r) => r.price));
}
